export enum LiquidUnit {
  Cups = "cups",
  FluidOunces = "floz",
  Pints = "pints",
  Milliliters = "ml",
  Liters = "l",
}
